import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export * from './selectors'
export * from './actions'

export const createClientSearchNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'client_search',
  text: translateFn('mnu_client_view'),
  identity: '/secure/client/searchGeneral',
  permission: 'VIEW_CLIENT',
}))

export default Loadable(() => import('./Components'))
